<style lang="scss">
.w-imbee-cookieBanner {

    position: absolute;
    bottom:0;
    width:100%;
    max-height: 100%;
    min-height:100px;
    background: var(--backgroundColorTransparent);
    box-shadow: 0 0 2px 2px var(--shadowColor);
    z-index: 1000;
    display:flex;
    line-height: 1.2;

    &, & * {
        box-sizing: border-box;
        color:var(--textColor);
    }

    & p{
        font-size:1em;
    }

    & h1{
        font-size:1.4em;
    }

    & h2{
        font-size:1.15em;
        padding: 10px 0;
        border-bottom:1px solid var(--separatorColor);
    }

    & h3{
        font-size:1.1em;
    }

    &__buttons {
        margin: 0 10px 10px;
        display: flex;
        justify-content: flex-end;

        @at-root button#{&}__button {
            display:block;
            border: 1px solid var(--buttonBorderColor);
            color: var(--buttonTextColor);
            background: var(--buttonBackgroundColor);
            padding:5px 10px;
            min-height: 42px;
            cursor:pointer;
            transition: color 150ms ease-in-out, background-color 150ms ease-in-out, border-color 150ms ease-in-out;
            font-size:11px;

            &:not(:last-child){
                margin-right:-1px;
            }

            &:first-child{
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
            }
            &:last-child{
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
            }

            &:hover{
                border-color: var(--buttonHoverBorderColor);
                color: var(--buttonHoverTextColor);
                background: var(--buttonHoverBackgroundColor);
            }

            &--cancelReject,
            &--allowAll {
                grid-area: allowAll;
                border: 1px solid var(--highlightedButtonBorderColor);
                background: var(--highlightedButtonBackgroundColor);
                color: var(--highlightedButtonTextColor);
                font-weight: bold;

                &:hover{
                    border-color: var(--highlightedButtonHoverBorderColor);
                    background-color: var(--highlightedButtonHoverBackgroundColor);
                    color: var(--highlightedButtonHoverTextColor);
                }
            }
            &--allowAll {
                flex: 0 1 40%;
            }
        }
    }

    &__banner {
        width:100%;
        max-height: 100%;
        display:flex;
        flex-direction: column;
        justify-content: flex-end;
        overflow: hidden;

        &__text {
            margin: 10px;
            color: #121212;
            overflow-x:hidden;
            overflow-y:auto;
            flex: 1 1 auto;
            font-size:11px;
        }

    }

    &--configuration{
        height:calc(100% - 60px);
    }
    &__configuration {
        position: absolute;
        bottom:0;
        width:100%;
        height: 100%;
        background: var(--backgroundColor);
        display:flex;
        flex-direction: column;
        justify-content: flex-end;
        overflow: hidden;

        &__text {
            margin: 10px;
            color: var(--textColor);
            overflow-x:hidden;
            overflow-y:auto;
            flex: 1 1 auto;
            font-size:13px;
        }
    }

    &--rejected{
        height:calc(100% - 60px);
    }
    &__rejected {
        position: absolute;
        bottom:0;
        width:100%;
        height: 100%;
        background: var(--backgroundColor);
        display:flex;
        flex-direction: column;
        justify-content: flex-end;
        overflow: hidden;

        &__text {
            margin: 10px;
            color: var(--textColor);
            overflow-x:hidden;
            overflow-y:auto;
            flex: 1 1 auto;
            font-size:13px;
        }
    }

}
</style>

<script>
export default {
    name: "Cookie-banner",
    props: {
        cookieData: { type: Object, default: {}}
    },
    data() {
        return {
            configurationView: false,
            rejectedView: this.cookieData?.cookiesAllowedCookie === "none",
        }
    },
    computed: {
        cssVars() {
            return {
                "--backgroundColorTransparent": this.cookieData?.backgroundColor + "e9",
                "--backgroundColor": this.cookieData?.backgroundColor,
                "--shadowColor": this.cookieData?.shadowColor + "22",
                "--textColor": this.cookieData?.textColor,
                "--separatorColor": this.cookieData?.separatorColor,
                "--buttonBackgroundColor": this.cookieData?.buttonBackgroundColor,
                "--buttonBorderColor": this.cookieData?.buttonBorderColor,
                "--buttonTextColor": this.cookieData?.buttonTextColor,
                "--buttonHoverBackgroundColor": this.cookieData?.buttonHoverBackgroundColor,
                "--buttonHoverBorderColor": this.cookieData?.buttonHoverBorderColor,
                "--buttonHoverTextColor": this.cookieData?.buttonHoverTextColor,
                "--highlightedButtonBackgroundColor": this.cookieData?.highlightedButtonBackgroundColor,
                "--highlightedButtonBorderColor": this.cookieData?.highlightedButtonBorderColor,
                "--highlightedButtonTextColor": this.cookieData?.highlightedButtonTextColor,
                "--highlightedButtonHoverBackgroundColor": this.cookieData?.highlightedButtonHoverBackgroundColor,
                "--highlightedButtonHoverBorderColor": this.cookieData?.highlightedButtonHoverBorderColor,
                "--highlightedButtonHoverTextColor": this.cookieData?.highlightedButtonHoverTextColor,
            }
        }
    },
    methods: {
        handleAllowAll() {
            this.rejectedView = false
            this.$cookie.set('cookiesAllowed', 'all', { expires: '1Y' })
            this.$emit("closeCookieBanner")
        },
        handleConfigure() {
            this.configurationView = true
            this.rejectedView = false
        },

        handleRejectAll() {
            this.rejectedView = true
            this.$cookie.set('cookiesAllowed', 'none', { expires: '1Y' })
        },
        handleAllowStrict() {
            this.configurationView = false
            this.rejectedView = false
            this.$cookie.set('cookiesAllowed', 'strict', { expires: '1Y' })
            this.$emit("closeCookieBanner")
        },
        handleCancelConfigure() {
            this.configurationView = false
            this.rejectedView = false
        },
    },
}

const deleteAllCookies =()=>{
    let cookies = document.cookie.split("; ")
    cookies.forEach(cookie=>{
        let d = window.location.hostname.split(".");
        while (d.length > 0) {
            let cookieBase = encodeURIComponent(cookie.split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
            let p = location.pathname.split('/');
            document.cookie = cookieBase + '/';
            while (p.length > 0) {
                document.cookie = cookieBase + p.join('/');
                p.pop();
            }
            d.shift();
        }
    })
    window.localStorage.clear()
}
</script>

<template>
    <div v-show="cookieData.show" class="w-imbee-cookieBanner"
         :style="cssVars"
         v-bind:class="{'w-imbee-cookieBanner--rejected': this.rejectedView, 'w-imbee-cookieBanner--configuration': this.configurationView}"
    >

        <div class="w-imbee-cookieBanner__banner">

            <div class="w-imbee-cookieBanner__banner__text" v-html="cookieData.text"/>

            <div class="w-imbee-cookieBanner__buttons">

                <button class="w-imbee-cookieBanner__buttons__button w-imbee-cookieBanner__buttons__button--allowStrict"
                        @click="handleConfigure"
                >
                    {{cookieData.configureText}}
                </button>

                <button class="w-imbee-cookieBanner__buttons__button w-imbee-cookieBanner__buttons__button--allowAll"
                        @click="handleAllowAll"
                >
                    {{cookieData.allowAllText}}
                </button>

            </div>

        </div>

        <div class="w-imbee-cookieBanner__configuration" v-show="this.configurationView">

            <div class="w-imbee-cookieBanner__configuration__text" v-html="cookieData.configurationText"/>

            <div class="w-imbee-cookieBanner__buttons">

                <button class="w-imbee-cookieBanner__buttons__button"
                        @click="handleRejectAll"
                >
                    {{cookieData.rejectAllText}}
                </button>

                <button class="w-imbee-cookieBanner__buttons__button"
                        @click="handleAllowStrict"
                >
                    {{cookieData.allowStrictText}}
                </button>

                <button class="w-imbee-cookieBanner__buttons__button w-imbee-cookieBanner__buttons__button--cancelReject"
                        @click="handleCancelConfigure"
                >
                    {{cookieData.cancelText}}
                </button>

            </div>

        </div>

        <div class="w-imbee-cookieBanner__rejected" v-show="this.rejectedView">

            <div class="w-imbee-cookieBanner__rejected__text" v-html="cookieData.rejectedText"/>

            <div class="w-imbee-cookieBanner__buttons">

                <button class="w-imbee-cookieBanner__buttons__button w-imbee-cookieBanner__buttons__button--allowStrict"
                        @click="handleConfigure"
                >
                    {{cookieData.configureText}}
                </button>

                <button class="w-imbee-cookieBanner__buttons__button w-imbee-cookieBanner__buttons__button--allowAll"
                        @click="handleAllowAll"
                >
                    {{cookieData.allowAllText}}
                </button>

            </div>

        </div>
    </div>

</template>



// WEBPACK FOOTER //
// CookieBanner.vue?9d530066